// Duration constants in seconds (matching tokens.css ms values / 1000)
export const DURATIONS = {
  INSTANT:   0.12,
  FAST:      0.24,
  BASE:      0.44,
  SLOW:      0.72,
  CINEMATIC: 1.2,
  EPIC:      2.2,
} as const

// Stagger values in seconds (matching tokens.css --stagger-* values)
export const STAGGERS = {
  CHAR:    0.02,
  WORD:    0.06,
  ELEMENT: 0.14,
} as const

// GSAP ease strings — BIOSOIL custom ease is registered in gsapSetup.ts
export const EASES = {
  CINEMATIC: 'power3.out',         // cubic-bezier(.22,1,.36,1)
  UNEARTH:   'expo.out',           // cubic-bezier(.16,.84,.44,1)
  DROP:      'power2.inOut',       // cubic-bezier(.55,0,.35,1)
  SPRING:    'back.out(1.7)',       // cubic-bezier(.34,1.56,.64,1)
  LINEAR:    'none',
  BIOSOIL:   'biosoil',            // cubic-bezier(.77,0,.175,1) — registered in gsapSetup
} as const

export type EaseKey = keyof typeof EASES
export type DurationKey = keyof typeof DURATIONS
